import { render, staticRenderFns } from "./FormGroupList.vue?vue&type=template&id=6515b22d&"
import script from "./FormGroupList.vue?vue&type=script&lang=js&"
export * from "./FormGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports